function Knapsack({ values, weights = values, n = values.length, target }) {
	const lookup = new Array(target + 1).fill(0);
	for (let i = 0; i <= target; i++) for (let j = 0; j < n; j++) if (weights[j] <= i) lookup[i] = Math.max(lookup[i], lookup[i - weights[j]] + values[j]);
	return lookup[target];
}
export { Knapsack };

//# sourceMappingURL=index248.js.map